import UserUpdateInformation from './userUpdateInformation'
import UserUpdateText from './userUpdateText'

export { UserUpdateInformation, UserUpdateText }
